import { FC } from "react";
import { Typography } from "@mui/material";
import { EventNotificationsUpdateReqDto } from "service/api/estabrookSchemas";
import { NotificationsTypeEnum } from "service/types/enum/notifications-enum";
import FormField from "../../../shared/components/FormField";
import FormLayout from "../../../shared/components/FormLayout";
import NotificationTypeSelector from "../../../shared/components/NotificationTypeSelector";
import { ExtendedFormProps } from "../../../shared/types/formTypes";

interface EventNotificationFormProps
  extends ExtendedFormProps<EventNotificationsUpdateReqDto> {
  deliveryText?: string;
  defaultMessage?: string;
}

const EventNotificationForm: FC<EventNotificationFormProps> = ({
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  deliveryText,
  setFieldValue,
  defaultMessage,
}) => {
  const handleMessageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setFieldValue("notificationCustomMessage", newValue);
  };

  const handleNotificationTypeChange = (newValue: string[]) => {
    setFieldValue("notificationType", newValue as NotificationsTypeEnum[]);
  };

  return (
    <FormLayout>
      <FormField
        label="Title"
        id="notificationTitle"
        placeholder="Enter title"
        value={values.notificationTitle}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
      />
      <FormField
        label="Notification Type"
        id="notificationType"
        touched={touched}
        errors={errors}
        labelProps={{ fontWeight: 600, alignSelf: "flex-start" }}
      >
        <NotificationTypeSelector
          value={values.notificationType}
          onChange={handleNotificationTypeChange}
        />
      </FormField>
      <FormField
        label="Delivery"
        id="delivery"
        touched={touched}
        errors={errors}
      >
        <Typography fontWeight={400} color="text.secondary">
          {deliveryText ||
            "This notification is automatically sent when route events occur"}
        </Typography>
      </FormField>
      <FormField
        label="Message"
        id="notificationCustomMessage"
        placeholder={defaultMessage || "Enter message"}
        value={values.notificationCustomMessage}
        onChange={handleMessageChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        multiline
        rows={5}
        labelProps={{ fontWeight: 600, alignSelf: "flex-start" }}
      />
    </FormLayout>
  );
};

export default EventNotificationForm;
